import { createAsyncThunk } from '@reduxjs/toolkit';
import { ACTIVEMACHINELIST } from '@custom/constant';
import { ActiveMachineListArgs } from '@custom/Utils/constants/interfaces';

// Async thunk for fetching the active machine list
export const fetchActiveMachineList = createAsyncThunk(
  'machine/fetchActiveMachineList',
  async ({ limit, pageNumber,search }: ActiveMachineListArgs, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(ACTIVEMACHINELIST, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            limit: limit,
            pageNumber: pageNumber,
            search: search,  // Include the search parameter in the body
          }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch active machine list');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default fetchActiveMachineList;
